import { render, staticRenderFns } from "./JianKang_taskmana.vue?vue&type=template&id=8438b3ea&scoped=true"
import script from "./JianKang_taskmana.vue?vue&type=script&lang=js"
export * from "./JianKang_taskmana.vue?vue&type=script&lang=js"
import style0 from "./JianKang_taskmana.vue?vue&type=style&index=0&id=8438b3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438b3ea",
  null
  
)

export default component.exports